import React, { useCallback, useEffect, useState } from 'react'
import { get } from 'services/api'
import { useSelector } from 'react-redux'
import { CircularProgress } from '@mui/material'

import { InfoOutlined } from '@mui/icons-material'
import moment from 'moment'
import Container, { LoadingWrapper, NoDataWrapper, Table } from './styles'

function BuildFeed(props) {
  const { url } = props
  const token = useSelector(state => state.auth.access_token)
  
  const [logData, setLogData] = useState(null)
  const [loading, setLoading] = useState(false)
  
  const load = useCallback(async () => {
    setLoading(true)
    const { data } = await get({
      url: url,
      token: token,
    })
    
    if (data) {
      setLogData(data)
    }
    setLoading(false)
  }, [url, token])
  
  useEffect(() => {
    load()
  }, [load])
  
  return (
    <Container>
      {loading ? (
        <LoadingWrapper>
          <CircularProgress />
        </LoadingWrapper>
      ) : (
        logData?.entries || logData?.activities ? (  
          <Table>
            <thead>
              {
                logData?.activities ?
                  (
                    <tr>
                      <th>Data e hora da atividade</th>
                      <th>Atividade</th>
                    </tr>
                  ) 
                : null
              }
              {
                logData?.entries ?
                  (
                    <tr>
                      <th>Data e hora do evento</th>
                      <th>Campo Greenhouse</th>
                      <th>Movimentação</th>
                    </tr>
                  ) 
                : null
              }
            </thead>
            <tbody>
              
              {logData?.activities?.map(activity => {
                return (
                  <tr key={activity.created_at}>
                    <td className='date-time'>
                      {moment(activity.created_at).format('DD/MM/YYYY HH:mm:ss')}
                    </td>
                    <td>
                      {activity.body}
                    </td>
                  </tr>
                )
              })}
              {logData?.entries?.map(entry => {
                return (
                  <tr key={entry.uuid}>
                    <td className='date-time'>
                      {moment(entry.created).format('DD/MM/YYYY \n HH:mm:ss')}
                    </td>
                    <td>
                      {entry.greenhouse_field || 'N/A'}
                    </td>
                    <td>
                      {entry.message}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        ) : (
          <NoDataWrapper>
            <span><InfoOutlined fontSize='inherit' /></span>
            <span>Nenhuma atividade encontrada para esse candidato</span>
          </NoDataWrapper>
        )
      )}
    </Container>
  )
}

export default BuildFeed
